import config from '../config'
export default {
  placeOrder: (data) => window.axios.post('order/place', data),
  addOrderRating: (data) => window.axios.post('rating/add', data),
  checkRating: (data) => window.axios.get(`rating/check/${data.order_id}`, data),
  reorderDetails: (data) => window.axios.get(`order/${data.order_id}/reorder`, data),
  cartDetails: (data) => window.axios.post('cart', data),
  uploadOrderImages: (data) => window.axios.post('order/upload-image', data),
  removeOrderImages: (data) => window.axios.post('order/remove-image', data),
  getPorterCharges: (data) => window.axios.post('delivery-charge/porter', data),



  trackOrderCustomer: (data) =>
    window.axios.post('track_of_driver_customer', data),


  getOrderDistance: (data) => window.axios.post('get-order-distance', data),

  // deliveryZone: (data) => window.axios.post('get-vendor-settings', data,),
  getSubscription: (data) => window.axios.post('subscription/create', data,),
  checkSubscriptionPromocode: (data) => window.axios.post('check_subscription_item_promocode', data,),
  // deliveryZone: (data) =>
  //   window.axios.post(
  //     'get-vendor-settings?' +
  //     'vendor_id=' +
  //     data.vendor_id +
  //     '&is_langauge=en' +
  //     '&longitude=' +
  //     +data.lan +
  //     '&latitude=' +
  //     +data.lat + '&order_web=' + 'dev.deonde.co',
  //   ),

  getCurrentOrdersWithratings: (data) =>
    window.axios.post('current_orders_withratings', data),
}
